module.exports = __webpack_public_path__ + "img/key.b6de7ab1.png";